import UploadFailed from '../../src/legacy/UploadFailed.tsx';
export default UploadFailed;
